<div class="container-fluid container-fluid-top" style="overflow-x: hidden">
  <!-- Left Sidebar -->
  <div class="left-sidebar" style="width: 3%">
    <app-sidebarforaccounts></app-sidebarforaccounts>
  </div>
  <!-- Center Section -->
  <div class="center-section">
    <h2 class="mt-4">Account Setting</h2>
    <div class="center-section-main">
      <div class="row">
        <div class="col-sm-3">
          <div class="setting-tabs">
            <button
              class="mb-3 mybtn p-2 mt-3 ms-1 d-flex"
              [ngClass]="{ active: selectedTab === 'tab1' }"
              (click)="selectTab('tab1')"
              id="adv-techs"
            >
              <img
                id="general-setting"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="general-setting"
              />
              <h3>General Setting</h3>
            </button>
            <button
              class="mb-3 mybtn p-2 ms-1 d-flex"
              [ngClass]="{ active: selectedTab === 'tab2' }"
              (click)="selectTab('tab2')"
              id="adv-techs"
            >
              <img
                id="dictory"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="dictory"
              />
              <h3>Dictionary</h3>
            </button>
            <button
              class="mb-3 mybtn p-2 ms-1 d-flex"
              [ngClass]="{ active: selectedTab === 'tab3' }"
              (click)="selectTab('tab3')"
              id="adv-techs"
            >
              <img
                id="lang"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="lang"
              />
              <h3>Language</h3>
            </button>

            <button
              class="mb-3 mybtn p-2 ms-1 d-flex"
              [ngClass]="{ active: selectedTab === 'tab5' }"
              (click)="selectTab('tab5')"
              id="adv-techs"
            >
              <img
                id="subscription"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="subscription"
              />
              <h3>Subscription</h3>
            </button>
            <button
              class="mb-3 mybtn p-2 ms-1 d-flex"
              [ngClass]="{ active: selectedTab === 'tab6' }"
              (click)="selectTab('tab6')"
              id="adv-techs"
            >
              <img
                id="security"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="security"
              />
              <h3>Security Overview</h3>
            </button>
          </div>
        </div>
        <div class="col-sm-9">
          <div
            *ngIf="selectedTab === 'tab1'"
            style="padding: 20px 20px 20px 0px"
            class="setting"
          >
            <h3>General Settings</h3>
            <hr style="color: #b6b8bb; margin-top: -2px" />
            <div
              class="tw0-divs"
              style="display: flex; justify-content: space-between"
            >
              <div
                style="
                  overflow-x: hidden;
                  overflow-y: auto !important;
                  height: 76vh;
                  width: -webkit-fill-available;
                "
                class="h-profile"
              >
                <div class="d-flex" style="justify-content: space-between">
                  <h4>User Update</h4>
                </div>
                <div class="d-flex">
                  <div class="mr-3 f-name" style="width: 73%">
                    <label for="firstname" class=""> Name</label>
                    <input
                      (ngModelChange)="capitalize()"
                      type="text"
                      name="firstname"
                      id="firstname"
                      ngDefaultControl
                      class="form-control"
                      required
                      placeholder="First Name"
                      autofocus
                      required="required"
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='First Name'"
                      value="{{ firstName }}"
                    />
                  </div>
                </div>
                <div>
                  <div class="">
                    <label for="email" class="">Email</label>
                    <input
                      id="email"
                      type="text"
                      style="height: 46px !important; width: 75%"
                      name="email_accountupdate"
                      ngDefaultControl
                      class="form-control"
                      required
                      placeholder="Email"
                      value="{{ emailAddress }}"
                      readonly
                      onfocus="this.placeholder=''"
                      onblur="this.placeholder='Email'"
                    />
                  </div>
                </div>
                <br />
                <button
                  type="submit"
                  class="wid380 submitName mt-3"
                  style="margin-top: 61px"
                  (click)="
                    updateProfileNames(
                      model.new_password1,
                      model.new_password12,
                      model.password_old
                    )
                  "
                >
                  Update Name
                </button>
              </div>
              <div style="float: left" *ngIf="comefromsite">
                <div class="mt-2 password-section">
                  <div class="p-3">
                    <h4 class="">Password</h4>
                    <div class="col-sm-12 wid380">
                      <span
                        toggle="#password-field"
                        class="fa fa-fw fa-eye field_icon toggle-password99 eyeicon float-right"
                      ></span>
                      <input
                        placeholder="Current password"
                        value="password_old"
                        name="password_old"
                        autocomplete="off"
                        onfocus="this.placeholder=''"
                        [(ngModel)]="model.password_old"
                        ngDefaultControl
                        name="password_old"
                        value="password_old"
                        onblur="this.placeholder='Current password'"
                        id="pass_log_id99"
                        type="password"
                        class="form-control"
                      />
                    </div>
                    <div class="col-sm-12 mt-3 wid380">
                      <span
                        toggle="#password-field"
                        class="fa fa-fw fa-eye field_icon toggle-password3 eyeicon float-right"
                      ></span>
                      <input
                        style="height: 46px !important"
                        placeholder="New password"
                        autocomplete="off"
                        value="new_password1"
                        name="new_password1"
                        minlength="8"
                        minlength="8"
                        onfocus="this.placeholder=''"
                        ngDefaultControl
                        [(ngModel)]="model.new_password1"
                        minlength="8"
                        name="new_password1"
                        value="new_password1"
                        onblur="this.placeholder='New password'"
                        id="pass_log_id3"
                        type="password"
                        name="pass"
                        type="password"
                        name="form_subject"
                        class="form-control"
                      />
                    </div>
                    <div *ngIf="visible">
                      <small
                        id="emailHelp"
                        class="form-text text-muted"
                        style="
                          float: right;
                          font-size: 14px;
                          margin-top: 1px !important;
                          margin-right: 22px;
                        "
                      >
                        Password must be 8 characters long</small
                      >
                    </div>
                    <div class="col-sm-12 mt-3 wid380">
                      <span
                        toggle="#password-field"
                        class="fa fa-fw fa-eye field_icon toggle-password2 eyeicon float-right"
                        style="padding-top: 18px"
                      ></span>
                      <input
                        style="height: 46px"
                        value="new_password12"
                        id="pass_log_id2"
                        name="new_password12"
                        placeholder="Confirm password"
                        autocomplete="off"
                        minlength="8"
                        ngDefaultControlminlength="8"
                        ngDefaultControl
                        [(ngModel)]="model.new_password12"
                        onfocus="this.placeholder=''"
                        onblur="this.placeholder='Confirm password'"
                        type="password"
                        class="form-control"
                      />
                    </div>
                    <button
                      type="submit "
                      class="wid380 submit mt-3"
                      (click)="
                        updatePassword(
                          model.new_password1,
                          model.new_password12,
                          model.password_old
                        )
                      "
                    >
                      Update Password
                    </button>
                    <div class="col-sm-12 col-md-12 col-sm-12 float-right">
                      <p
                        class="text-left px-3"
                        id="accountSetting_div"
                        style="
                          margin-top: -350px;
                          float: right;
                          font-size: 16px;
                          border-radius: 10px;
                          width: 367px;
                          padding: 5px;
                        "
                      >
                        <i
                          id="accountSetting_msgs"
                          style="margin-right: 3px"
                        ></i
                        >{{ accountSetting_msg }}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="error"
                  class="backdrop"
                  style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1000;
                  "
                ></div>

                <div
                  *ngIf="error"
                  class="content-div"
                  style="
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 468px;
                    height: 410px;
                    background-color: white;
                    z-index: 1010;
                    border-radius: 4px;
                    border: 1px solid white;
                  "
                >
                  <div class="text-center" style="margin-top: 16%">
                    <img src="/assets/images/paraphrasing tool/alert.svg" />

                    <div style="width: 440px; height: 64px; margin-left: 16px">
                      <p
                        class="error mt-4"
                        style="
                          font-size: 24px;
                          font-weight: 500;
                          line-height: 33.89px;
                        "
                      >
                        {{ errorAlerts }}
                      </p>
                    </div>

                    <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                      Ok
                    </button>
                  </div>
                </div>

                <div
                  *ngIf="success"
                  class="backdrop"
                  style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1000;
                  "
                ></div>

                <div
                  *ngIf="success"
                  class="content-div"
                  style="
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 468px;
                    height: 410px;
                    background-color: white;
                    z-index: 1010;
                    border-radius: 4px;
                    border: 1px solid white;
                  "
                >
                  <div class="text-center" style="margin-top: 16%">
                    <img
                      src="/assets/images/paraphrasing tool/success.svg"
                      style="width: 138px; height: 138px"
                    />

                    <p
                      *ngIf="success"
                      class="error mt-4"
                      style="
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 33.89px;
                      "
                    >
                      {{ successAlert }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Dictionary -->
          <div
            *ngIf="selectedTab === 'tab2'"
            style="padding: 20px 20px 20px 0px"
            class="dictnry"
          >
            <h3>Dictionary</h3>
            <hr style="color: #b6b8bb; margin-top: -2px" />
            <div class="d-flex">
              <p
                style="
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 19.36px;
                  text-align: left;
                "
              >
                Turn Dictionary on/off against this Document. Turn Dictionary
              </p>
              <div class="form-check form-switch-md mb-0 mt-1">
                <div class="on-off-toggle">
                  <input
                    class="on-off-toggle__input"
                    type="checkbox"
                    id="bopis"
                    (click)="toggleDictionary($event)"
                  />
                  <label for="bopis" class="on-off-toggle__slider"></label>
                </div>
              </div>
            </div>
            <form class="d-flex">
              <div class="input-group my-2 p-1 rounded modal-bd-light">
                <input
                  class="form-control me-2"
                  type="text"
                  ngDefaultControl
                  name="dictWord"
                  id="dictWord"
                  value="{{ dictWord }}"
                  [(ngModel)]="dictWord"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='Add a new word'"
                  placeholder="Add a new word"
                  aria-label="short_link"
                  style="
                    height: 50px;
                    background-color: white !important ;
                    color: #787878;
                    border: 1px solid #e5e5ed;
                    width: 100%;
                  "
                />
              </div>
              <div class="float-right mt-2 ms-3">
                <button
                  type="button"
                  class="btn btn-modal-dark add float-right"
                  (click)="updateUserDictionary()"
                  style="
                    width: 110px;
                    height: 50px;
                    border-radius: 8px;
                    background: #08ba9c;
                    color: white;
                  "
                >
                  Add
                </button>
              </div>
            </form>
            <div>
              <p
                style="
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 19.36px;
                  text-align: left;
                "
              >
                These words will no longer be flagged as misspellings.
              </p>
            </div>
            <div class="list-container">
              <div class="header">
                <h4>List of already added words</h4>
                <div class="search-wrapper">
                  <input
                    type="text"
                    placeholder="Search..."
                    class="search-bar"
                    type="text"
                    [(ngModel)]="searchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    onfocus="this.placeholder=''"
                    onblur="this.placeholder='Search'"
                    placeholder="Search"
                    aria-label="short_link"
                  />
                  <i class="fas fa-search search-icon"></i>
                </div>
              </div>
              <div
                class="row"
                id="dictonaryinnerbody"
                style="overflow: auto; margin-left: 1px; margin-right: 0px"
              >
                <table
                  class="table list-unstyled list_words"
                  style="border-spacing: 0 10px; border-collapse: separate"
                >
                  <tbody>
                    <img
                      src="../../assets/images/icons/nowordyet.svg"
                      alt="nowordyet"
                      *ngIf="!all_records?.length"
                      style="margin-top: 7%; margin-left: 42%"
                    />
                    <p
                      *ngIf="!all_records?.length"
                      class="text-center"
                      style="font-size: 16px; margin-top: 6px; margin-left: -8%"
                    >
                      No word yet
                    </p>
                    <p
                      style="
                        text-align: center;
                        margin-top: 10px;
                        margin-top: 40px;
                      "
                      *ngIf="
                        all_records?.length &&
                        (dictListing | filter : searchTerm).length == 0
                      "
                    >
                      <img
                        src="../../assets/images/No error found illustration/no word (1).svg"
                        alt="no-word"
                      />
                    </p>
                    <tr
                      *ngFor="let row of dictListing | filter : searchTerm"
                      style="
                        border-top-left-radius: 5px;
                        background-color: #f9f9fc;
                        height: 27px;
                      "
                    >
                      <td
                        style="
                          border-top-left-radius: 5px;
                          border-bottom-left-radius: 5px;
                          border-left: 1px solid #dee2e6;
                          background-color: #f9f9fc;
                          height: 27px;
                        "
                        class="col-lg-12 added_word"
                      >
                        {{
                          row.word.length > 20
                            ? (row.word | slice : 0 : 20) + "..."
                            : row.word
                        }}
                      </td>
                      <td
                        class="col-lg-12 remove_word"
                        style="
                          background-color: #f9f9fc;
                          height: 27px;
                          border: none;
                          border-top: 1px solid #dee2e6;
                          border-bottom: 1px solid #dee2e6;
                          margin-top: 0px;
                          border-top-right-radius: 5px;
                          border-bottom-right-radius: 5px;
                          border-right: 1px solid #dee2e6;
                        "
                        id="fileListMsg3_{{ row.doc_id }}"
                        (click)="deleteDictWord(row.dic_id)"
                      >
                        <img
                          src="/../../assets/images/account setting/cancel.svg"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <span
              class="upload-title p-2 float-left d-inline-block"
              style="color: green; margin-top: 7px"
              id="dictLoaderonoffmsg"
            ></span>
            <span
              class="upload-title p-2 float-left d-inline-block"
              style="color: green; margin-top: 7px"
              id="savefiletext3"
            ></span>
            <span
              class="upload-title p-2 float-left d-inline-block"
              style="color: red; margin-top: 7px"
              id="dictLoader"
            ></span>
            <p
              class="upload-title float-left d-inline-block"
              style="color: green; margin-top: 7px"
              id="savefiletext2"
            ></p>
          </div>
          <!-- language  -->
          <div
            *ngIf="selectedTab === 'tab3'"
            style="padding: 20px 20px 20px 0px"
            class="langs"
          >
            <h3>Language Setting</h3>
            <hr style="color: #b6b8bb; margin-top: -2px" />
            <div
              style="
                background: #ffffff;
                height: 78vh;
                border-radius: 8px;
                border: 1px solid #e5e5ed;
                padding: 20px;
                overflow-y: auto;
              "
            >
              <p class="languageP">I write in</p>
              <!-- button -->
              <div>
                <div class="menu-container">
                  <button class="menu-btn" (click)="toggleMenu()">
                    <div style="margin-top: -10px">
                      <img [src]="selectedLanguage.icon" class="me-2" />{{
                        selectedLanguage.name
                      }}
                      <img
                        src="../../assets/images/arrow.svg"
                        alt="nav-dropdown"
                        class="ms-2"
                      />
                    </div>
                  </button>
                  <div
                    id="menuContent"
                    class="menu-content"
                    [ngClass]="{ 'show-menu': isMenuOpen }"
                  >
                    <a
                      class="dropdown-item"
                      style="margin-top: 15px !important"
                      href="javascript:void(0)"
                      (click)="
                        selectLanguage(
                          'British English',
                          '../../assets/images/flag/British.svg'
                        )
                      "
                    >
                      <img
                        src="../../assets/images/flag/British.svg"
                        class="me-2 flag"
                      />
                      <span>British English</span>
                    </a>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      (click)="
                        selectLanguage(
                          'American English',
                          '../../assets/images/account setting/American.svg'
                        )
                      "
                    >
                      <img
                        src="../../assets/images/account setting/American.svg"
                        class="me-2 flag"
                      />
                      <span>American English</span>
                    </a>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      (click)="
                        selectLanguage(
                          'Canadian English',
                          '../../assets/images/account setting/Canadian.svg'
                        )
                      "
                    >
                      <img
                        src="../../assets/images/account setting/Canadian.svg"
                        class="me-2 flag"
                      />
                      <span>Canadian English</span>
                    </a>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      (click)="
                        selectLanguage(
                          'Australian English',
                          '../../assets/images/account setting/Australian.svg'
                        )
                      "
                    >
                      <img
                        src="../../assets/images/account setting/Australian.svg"
                        class="me-2 flag"
                      />
                      <span>Australian English</span>
                    </a>
                  </div>
                </div>
              </div>
              <!--   -->
              <p class="languageP mt-2">
                What is the basic difference b/w British & American English?
              </p>
              <p
                style="
                  font-size: 15px;
                  font-weight: 400;
                  line-height: 31px;
                  text-align: left;
                "
              >
                <img
                  src="/../../assets/images/account setting/check.svg"
                  class="me-2"
                />
                British and American English have some spelling differences.
              </p>
              <p
                style="
                  font-size: 15px;
                  font-weight: 400;
                  line-height: 31px;
                  text-align: left;
                  margin-top: -20px;
                "
              >
                <img
                  src="/../../assets/images/account setting/check.svg"
                  class="me-2"
                />
                The common ones are presented below.
              </p>
              <!--  -->
              <div class="row">
                <div class="col">
                  <span class="modal_text_med pb-2 languageP">
                    <img
                      src="/../../assets/images/account setting/American.svg"
                      class="me-2"
                    />American</span
                  >
                  <div
                    class="language_keywords mt-3"
                    style="font-size: 14px; font-weight: medium"
                  >
                    <span class="liss mt-2"
                      >-e- (e.g. anemia, diarrhea, encyclopedia)</span
                    >
                    <span class="lis mt-2"
                      >-ed (e.g. burned, dreamed, leaped)</span
                    >
                    <span class="liss mt-2"
                      >-ense (defense, offense, license)</span
                    >
                    <span class="lis mt-2"
                      >-el- (e.g. canceled, jeweler, marvelous)</span
                    >
                    <span class="liss mt-2"
                      >-ize (e.g. appetizer, familiarize, organize)</span
                    >
                    <span class="lis mt-2"
                      >-ll- (e.g. enroll, fulfill, skillfull)</span
                    >
                  </div>
                </div>
                <div class="col">
                  <span class="modal_text_med pb-2 languageP">
                    <img
                      src="/../../assets/images/account setting/British.svg"
                      class="me-2"
                    />British</span
                  >
                  <div
                    class="language_keywords mt-3"
                    style="font-size: 14px; font-weight: medium"
                  >
                    <span class="liss mt-2"
                      >-oe/-ae-(e.g. anaemia, diarrhoea, encyclopaedia)
                    </span>
                    <span class="lis mt-2">-t (e.g. burnt, dreamt, leapt)</span>
                    <span class="liss mt-2"
                      >-ence (e.g. defence, offence, licence)</span
                    >
                    <span class="lis mt-2"
                      >-ell- (e.g. cancelled, jeweller, marvellous)</span
                    >
                    <span class="liss mt-2"
                      >-ise (e.g. appetiser, familiarise, organise)</span
                    >
                    <span class="lis mt-2"
                      >-l- (e.g. enrol, fulfil, skilful)</span
                    >
                  </div>
                </div>
              </div>
              <div class="mt-5">
                <h3 class="languageP">
                  <img
                    src="/../../assets/images/account setting/Canadian.svg"
                    class="me-2"
                  />
                  Canadian
                </h3>
                <p class="mid">
                  Candian English follows most British Spelling, grammar, and
                  punctuation rules; so, most of the difference between British
                  and Ameriacn English also apply to Canadian English.
                </p>
                <p class="mid">
                  British, Canadian and Australisn English words with 'our' in
                  them are spelt with 'or' in American English.
                </p>
                <ul>
                  <li>
                    <b class="mt-1">British, Canadian and Australian:</b> Color,
                    Favourite
                  </li>
                  <li><b class="mt-1">American:</b> Color, Favourite</li>
                </ul>
                <p class="mid">
                  Words that end in '-re' in Australian and British English are
                  spelt with '-er' in American English.
                </p>
                <ul>
                  <li>
                    <b class="mt-1">British, Canadian and Australian:</b> Color,
                    Favourite
                  </li>
                  <li><b class="mt-1">American:</b> Color, Favourite</li>
                </ul>
              </div>
              <div class="mt-5">
                <h3 class="languageP">
                  <img
                    src="/../../assets/images/account setting/Australian.svg"
                    class="me-2"
                  />Australia
                </h3>
                <p class="mid">
                  Australian English follows Brtish spelling very closely but
                  many common words are spelt differntly in American English;
                  such as those ending with 'yse' or 'ise'.
                </p>
                <ul>
                  <li>
                    <b class="mt-1">British and Australian::</b> Analyse,
                    Apologise
                  </li>
                  <li><b class="mt-1">American:</b> Analyse, Apologize</li>
                </ul>
                <p class="mid">
                  There is exception in all verities, that contribute in their
                  similarities and differences with other varieties of language.
                </p>
                <ul>
                  <li>
                    Canadians write cheques / catalogues, while Americans write
                    catalogs / checks.
                  </li>
                  <li>
                    Canadians use US spellings for certain words
                    (e.g., aluminum instead of aluminium) and US terms over
                    British ones (e.g., gas instead of petrol)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Subscription -->
          <div
            *ngIf="selectedTab === 'tab5'"
            style="padding: 20px 20px 20px 0px; overflow: hidden"
            class="subs"
          >
            <h3>Subscription</h3>
            <hr style="color: #b6b8bb; margin-top: -2px" />
            <div
              style="
                height: 79vh;
                overflow-y: auto;
                overflow-x: hidden;
                padding-right: 20px;
              "
            >
              <div class="row just-set" style="overflow-x: hidden">
                <!-- Basic Plan -->
                <div class="col-lg-4 col-md-4"></div>
                <!-- You're currently using our free plan. Upgrade now to access premium features! -->
                <div class="col-lg-12 col-md-12" *ngIf="!premium_user_done">
                  <div class="planing" style="background-color: white">
                    <h5 style="margin-bottom: 20px">
                      <img
                        src="/assets/images/homepage/stars.svg"
                        class="me-2"
                      />
                      You're currently using our <b>FREE</b> plan. Upgrade now
                      to access <b>P</b>remium features!
                    </h5>
                    <div class="row pricing-plan g-4">
                      <div class="col-lg-4 col-md-6">
                        <div
                          class="plan-option"
                          id="Monthly"
                          [ngClass]="{
                            'plan-optionSelect': selectedPlan === 'Monthly',
                            hovered: hoveredPlan === 'Monthly'
                          }"
                          (mouseenter)="onHover('Monthly')"
                          (mouseleave)="onLeave()"
                          (click)="onSelect('Monthly')"
                        >
                          <div class="mb-4 pricingpercentText">
                            <div
                              class="plan-optionText"
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Monthly'
                              }"
                            >
                              Monthly
                            </div>
                            <div
                              class="div3 pricingpercent"
                              style="float: right"
                              [ngClass]="{
                                pricingpercentSelect: selectedPlan === 'Monthly'
                              }"
                            >
                              50% OFF
                            </div>
                          </div>
                          <h3>
                            <strong
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Monthly'
                              }"
                              >$7.50</strong
                            >
                            <del
                              class="ms-2"
                              style="font-size: 17px; font-weight: 300"
                              >$15</del
                            >
                          </h3>
                          <button
                            class="btn-ouline mt-4"
                            [ngClass]="{
                              'btn-ouline-green': selectedPlan === 'Monthly'
                            }"
                            *ngIf="
                              (!this.isUserLoggedin || this.isUserLoggedin) &&
                              !premium_user_done
                            "
                            (click)="
                              checkUserIdAndRoute(
                                'Monthly',
                                '$7.50',
                                'price_1Q6AFpIcvPV98dDokZi78LKx'
                              )
                            "
                          >
                            Select Plan
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div
                          class="plan-option plan-optionSelect"
                          id="Quarterly"
                          [ngClass]="{
                            'plan-optionSelect': selectedPlan === 'Quarterly',
                            hovered: hoveredPlan === 'Quarterly'
                          }"
                          (mouseenter)="onHover('Quarterly')"
                          (mouseleave)="onLeave()"
                          (click)="onSelect('Quarterly')"
                        >
                          <div class="mb-4 pricingpercentText">
                            <div
                              class="plan-optionText plan-optionText"
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Quarterly'
                              }"
                            >
                              Quarterly
                            </div>
                            <div
                              class="div3 pricingpercent"
                              [ngClass]="{
                                pricingpercentSelect:
                                  selectedPlan === 'Quarterly'
                              }"
                              style="float: right"
                            >
                              50% OFF
                            </div>
                          </div>
                          <h3>
                            <strong
                              class="plan-optionSelectText"
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Quarterly'
                              }"
                              >$15</strong
                            >
                            <del
                              class="ms-2"
                              style="font-size: 17px; font-weight: 300"
                              >$30</del
                            >
                          </h3>
                          <button
                            class="btn-ouline mt-4"
                            [ngClass]="{
                              'btn-ouline-green': selectedPlan === 'Quarterly'
                            }"
                            *ngIf="
                              (!this.isUserLoggedin || this.isUserLoggedin) &&
                              !premium_user_done
                            "
                            (click)="
                              checkUserIdAndRoute(
                                'Quarterly',
                                '$15',
                                'price_1Q6AeuIcvPV98dDoc2fUYvhM'
                              )
                            "
                          >
                            Select Plan
                          </button>
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-6">
                        <div
                          class="plan-option"
                          id="Yearly"
                          [ngClass]="{
                            'plan-optionSelect': selectedPlan === 'Yearly',
                            hovered: hoveredPlan === 'Yearly'
                          }"
                          (mouseenter)="onHover('Yearly')"
                          (mouseleave)="onLeave()"
                          (click)="onSelect('Yearly')"
                        >
                          <div class="mb-4 pricingpercentText">
                            <div
                              class="plan-optionText"
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Yearly'
                              }"
                            >
                              Yearly
                            </div>
                            <div
                              class="div3 pricingpercent"
                              [ngClass]="{
                                pricingpercentSelect: selectedPlan === 'Yearly'
                              }"
                              style="float: right"
                            >
                              50% OFF
                            </div>
                          </div>
                          <h3>
                            <strong
                              [ngClass]="{
                                'plan-optionSelectText':
                                  selectedPlan === 'Yearly'
                              }"
                              >$40</strong
                            >
                            <del
                              class="ms-2"
                              style="font-size: 17px; font-weight: 300"
                              >$80</del
                            >
                          </h3>
                          <button
                            class="btn-ouline mt-4"
                            [ngClass]="{
                              'btn-ouline-green': selectedPlan === 'Yearly'
                            }"
                            *ngIf="
                              (!this.isUserLoggedin || this.isUserLoggedin) &&
                              !premium_user_done
                            "
                            (click)="
                              checkUserIdAndRoute(
                                'annual',
                                '$40',
                                'price_1Q6Ag7IcvPV98dDoHGszhDz0'
                              )
                            "
                          >
                            Select Plan
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4">
                      <h4 class="mb-5 upgradePhone">
                        <img
                          src="/assets/images/homepage/stars.svg"
                          class="me-2"
                        />Upgrade to Access
                      </h4>
                      <div class="flex-container">
                        <ul class="list-unstyled ul-list">
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />Everything included in Free Account
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Improve your writing tone
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Rewrite full sentences for Clarity
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Extensive Sentiment Analysis
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Refine your writing style and syntax
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Unlimited Plagiarism Check
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Unlimited Text Summarizer
                          </li>
                        </ul>
                        <ul class="list-unstyled">
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Unlimited Paraphrasing
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Insightful Reports
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            Centralized billing & Dedicated Support
                          </li>
                          <li>
                            <img
                              src="/assets/images/homepage/tick.svg"
                              class="me-2"
                            />
                            2,000 AI prompts/month for AI Assistant and AI Tools
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between" *ngIf="subscribed_user">
                <h3>Billing History</h3>
                <button
                  (click)="unsubscribeplan()"
                  style="
                  border-radius: 4px;
                  border: 1px solid #e3e3f0;"
                >
                  <!-- <img src="/../../assets/images/account setting/download.svg" /> -->Unsubscribe
                  Plan
                </button>
                <!-- <h6 style="float: right;">Unsubscribe Plan</h6> -->
              </div>
              <!--  -->
              <div
                class="table-responsive mt-3"
                *ngIf="getsubscriptionhistory.length > 0"
              >
                <table class="table table-hover align-middle">
                  <thead class="table-light">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Description</th>
                      <th scope="col">Status</th>
                      <th scope="col" style="text-align: center">Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let data of getsubscriptionhistory; let i = index"
                      style="text-align: left"
                    >
                      <td>{{ data?.start | date }}</td>
                      <td>${{ data?.price }}</td>
                      <td>{{ data?.name }}</td>
                      <td>{{ data?.status | titlecase }}</td>
                      <td style="text-align: center">
                        <img
                          src="/../../assets/images/download_invoice.svg"
                          alt="down"
                          style="cursor: pointer"
                          (click)="downloadinvoice(data?.inv_no)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
            </div>
          </div>

          <div
            *ngIf="selectedTab === 'tab6'"
            class=""
            style="padding: 20px 20px 20px 0px; overflow: hidden"
            class="scety-over"
          >
            <h3>Security Overview</h3>
            <hr style="color: #b6b8bb; margin-top: -2px" />
            <div
              class="row"
              style="display: flex; justify-content: space-between"
            >
              <div
                class="col-sm-7"
                style="overflow-x: hidden; overflow-y: auto !important"
              >
                <div class="emails">
                  <p class="mid">
                    <span class="me-5"> Registered email: </span>
                    {{ emailAddress }}
                  </p>
                </div>
                <hr class="hr" width="50%" />

                <div>
                  <h3>Devices</h3>
                  <span class="mid">
                    your are signed in to your GrammarIn account on the
                    following devices</span
                  >
                </div>
                <div class="mt-2" (click)="logout()">
                  <button class="green p-2 btnText">
                    Sign out all devices
                  </button>
                </div>
                <div class="dropdown mt-3">
                  <button class="dropbtn drop" (click)="toggleDropdown()">
                    <img
                      src="/../../assets/images/account setting/window icin.svg"
                      class="ms-3 mt-2"
                    />
                    <div class="d-grid" style="margin-left: 20px">
                      <span class="">
                        {{ info_os }} . {{ info_city }} ,
                        {{ info_country }}</span
                      >
                      <span class="">
                        {{ info_browser }} - {{ info_app }}
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div
                class="col-sm-4"
                style="
                  float: left;
                  overflow-x: hidden;
                  overflow-y: auto !important;
                  max-height: 80vh;
                "
              >
                <h3>Privacy</h3>
                <p class="sideFont">
                  Your trust is important to us. We will go to great lengths to
                  ensure that your data is private and secure. Read about our
                  user-first approach to privacy and security on our trust
                  center.
                  <a href="/privacy-policy" style="color: green">Click Here</a>
                </p>

                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
